export const colorElementOverlayLight = "rgb(255, 255, 255)";
export const colorElementOverlayDark = "rgb(37, 37, 65)";